module.exports = __webpack_public_path__ + "static/hellofresh-d77d7e14d8313b3c46d08cd557317a63.jpeg";